import { __rest } from "tslib";
import * as React from "react";
import { connect } from "react-redux";
import { Intent, NotificationContext, withContext, Button, Popover, Menu, Position, MenuItem, Tooltip, } from "@focus/focusUI";
import { ErrorListComponent } from "../errors/ErrorListComponent";
import { ListTableWrapper } from "./ListTable";
import { ListButton } from "./ListButton";
import { ListFormDialog } from "./ListFormDialog";
import "./List.scss";
import { getUiProperties, getColumnDataUpdated } from "../utils/utils";
import { getUnconditionalSchema } from "../utils/validation";
import { changeFromSchemaAndValue } from "../entities/formData";
import clipboardCopy from "@focus/services/lib/clipboard/clipboardCopy";
import clipboardPaste from "@focus/services/lib/clipboard/clipboardPaste";
import { addRow, deleteRow, duplicateRow, moveRowDown, moveRowUp, pasteRow, } from "../entities/formList";
export class List extends React.Component {
    constructor(props) {
        super(props);
        this.uiSchema = this.props.uiSchema;
        this.agGridApi = null;
        this.gridColumnApi = null;
        this.onGridReady = (params) => {
            this.agGridApi = params.api;
            this.gridColumnApi = params.columnApi;
        };
        this.onFirstDataRendered = () => {
            this.gridColumnApi.autoSizeAllColumns();
        };
        this.openDialog = (schema) => () => {
            if (typeof schema.items === "undefined" ||
                typeof this.props.formData === "undefined" ||
                (this.props.formData && this.props.formData.length === 0)) {
                return;
            }
            this.setState({
                isDialogOpen: true,
            });
        };
        this.handleDoubleClick = (schema) => (index) => {
            this.setState({
                focusedRow: index,
            });
            this.openDialog(schema)();
        };
        this.handleRowSelect = () => {
            const selectedRow = this.agGridApi.getSelectedNodes();
            let indexes = [];
            if (selectedRow.length > 1) {
                selectedRow.forEach((row) => {
                    indexes.push(row.rowIndex);
                    this.setState({ focusedRow: row.rowIndex });
                });
                this.setState({ selectedRow: indexes });
            }
            else {
                this.setState({ focusedRow: selectedRow[0].rowIndex, selectedRow: [] });
            }
        };
        this.handleAdd = (formData, schema) => () => {
            const newFormData = addRow(formData, schema, this.uiSchema);
            this.setState({
                currentData: newFormData,
            });
            this.props.onChange(newFormData, changeFromSchemaAndValue(schema, newFormData));
        };
        this.handleDelete = (formData) => () => {
            const selectedRows = this.agGridApi.getSelectedNodes();
            if (formData.length === 0)
                return;
            const { newFormData, selectedIndexes } = deleteRow(formData, selectedRows);
            let columnName = this.agGridApi.getFocusedCell().column.colId;
            let focusedRowIndex;
            if (newFormData.length !== 0 && selectedIndexes.length !== 0) {
                const lastSelectedIndex = selectedIndexes[selectedIndexes.length - 1];
                const lastDeletedWasNotLastOne = newFormData.length - 1 > lastSelectedIndex;
                focusedRowIndex = lastDeletedWasNotLastOne
                    ? lastSelectedIndex
                    : newFormData.length - 1;
                if (this.agGridApi && focusedRowIndex) {
                    this.agGridApi.setFocusedCell(focusedRowIndex, columnName, null);
                    this.agGridApi.ensureIndexVisible(focusedRowIndex, undefined);
                }
            }
            else {
                focusedRowIndex = null;
            }
            this.setState({
                focusedRow: focusedRowIndex,
                selectedRow: [],
                currentData: newFormData,
            });
            this.props.onChange(newFormData, changeFromSchemaAndValue(this.props.schema, newFormData));
        };
        this.handleDuplicate = () => {
            const formData = this.props.formData;
            const selectedRows = this.agGridApi.getSelectedRows();
            if (formData.length === 0)
                return;
            if (formData.length === 0 || selectedRows.length === 0) {
                this.props.showNotification({
                    icon: "warning-sign",
                    intent: Intent.WARNING,
                    message: "Nothing to duplicate!",
                });
                return;
            }
            const currentFormData = duplicateRow(formData, selectedRows);
            this.setState({
                focusedRow: null,
                selectedRow: [],
                currentData: currentFormData,
            });
            this.props.onChange(currentFormData, changeFromSchemaAndValue(this.props.schema, currentFormData));
        };
        this.handleCopy = () => {
            if (this.props.formData.length === 0)
                return;
            const copyRows = this.agGridApi.getSelectedRows();
            const rowsAndSchema = {
                isRow: true,
                rows: copyRows,
            };
            clipboardCopy(rowsAndSchema, true);
            this.agGridApi.deselectAll();
            this.props.showNotification({
                icon: "tick",
                intent: Intent.SUCCESS,
                message: "Row successfully copied",
            });
        };
        this.handlePaste = async () => {
            let copiedRows;
            try {
                copiedRows = await clipboardPaste();
            }
            catch (_a) {
                this.props.showNotification({
                    icon: "warning-sign",
                    intent: Intent.WARNING,
                    message: "Nothing to paste!",
                });
            }
            if (copiedRows === undefined || copiedRows.isRow === false) {
                return;
            }
            const selectedRows = this.agGridApi.getSelectedNodes();
            const currentFormData = pasteRow(this.props.formData, copiedRows.rows, this.props.schema, selectedRows);
            if (currentFormData !== null) {
                this.setState({
                    focusedRow: null,
                    selectedRow: [],
                    currentData: currentFormData,
                });
                this.props.onChange(currentFormData, changeFromSchemaAndValue(this.props.schema, currentFormData));
                this.props.showNotification({
                    icon: "tick",
                    intent: Intent.SUCCESS,
                    message: "Row successfully pasted",
                });
            }
            else {
                this.props.showNotification({
                    icon: "warning-sign",
                    intent: Intent.WARNING,
                    message: "Cant paste this row, panel configuration does not match!",
                });
                return;
            }
        };
        this.handleMoveUp = () => () => {
            if (this.agGridApi) {
                if (this.state.selectedRow.length === 0) {
                    const currenFormData = moveRowUp(this.props.formData, this.state.focusedRow);
                    this.setState({
                        focusedRow: this.state.focusedRow - 1,
                        selectedRow: [],
                        currentData: currenFormData,
                    });
                    this.props.onChange(currenFormData, changeFromSchemaAndValue(this.props.schema, currenFormData));
                }
                else {
                    this.props.showNotification({
                        icon: "warning-sign",
                        intent: Intent.WARNING,
                        message: "Cannot move more than one row at once!",
                    });
                }
            }
        };
        this.handleMoveDown = () => () => {
            if (this.agGridApi) {
                if (this.state.selectedRow.length === 0) {
                    const currenFormData = moveRowDown(this.props.formData, this.state.focusedRow);
                    this.setState({
                        focusedRow: this.state.focusedRow + 1,
                        selectedRow: [],
                        currentData: currenFormData,
                    });
                    this.props.onChange(currenFormData, changeFromSchemaAndValue(this.props.schema, currenFormData));
                }
                else {
                    this.props.showNotification({
                        icon: "warning-sign",
                        intent: Intent.WARNING,
                        message: "Cannot move more than one row at once!",
                    });
                }
            }
        };
        this.changeRow = (newRow) => {
            this.setState({ focusedRow: newRow });
        };
        this.handleDialogChange = (rowData) => {
            let newData = this.state.currentData.slice();
            newData[this.state.focusedRow] = rowData;
            this.setState({ currentData: newData });
        };
        this.handleNextButton = () => {
            let newRow = this.state.focusedRow + 1;
            if (newRow > this.state.currentData.length - 1) {
                newRow = 0;
            }
            this.changeRow(newRow);
        };
        this.handlePreviousButton = () => {
            let newRow = this.state.focusedRow - 1;
            if (newRow < 0) {
                newRow = this.state.currentData.length - 1;
            }
            this.changeRow(newRow);
        };
        this.handleCloseWithoutSaving = () => {
            this.setState({
                currentData: this.props.formData,
                isDialogOpen: false,
            });
        };
        this.handleCloseAndSave = () => {
            this.setState({
                isDialogOpen: false,
            });
            this.props.onChange(this.state.currentData, changeFromSchemaAndValue(this.props.schema, this.state.currentData));
        };
        this.exportCSVList = () => {
            const schema = getUnconditionalSchema(this.props.schema, this.props.formData);
            const options = {
                fileName: schema.title === ""
                    ? "exported_list"
                    : schema.title.toLowerCase().replace(/ /g, "_"),
            };
            this.agGridApi.exportDataAsCsv(options);
        };
        this.setFieldColumn = (headerData) => {
            let newData = this.props.formData.slice();
            let dataUpdated = getColumnDataUpdated(newData, headerData, this.uiSchema);
            this.props.onChange(dataUpdated, changeFromSchemaAndValue(this.props.schema, dataUpdated));
            this.props.showNotification({
                icon: "tick",
                intent: Intent.SUCCESS,
                message: "Field setted for all rows",
            });
        };
        this.state = {
            selectedRow: [],
            isDialogOpen: false,
            focusedRow: null,
            currentData: this.props.formData,
        };
    }
    componentDidUpdate(prevProps) {
        if (this.props.formData !== prevProps.formData) {
            this.setState({
                currentData: this.props.formData,
            });
        }
    }
    createButtons(isDisabled, isReadOnly, formData, schema) {
        const noRowsSelected = !(this.agGridApi && this.agGridApi.getSelectedRows().length > 0);
        return (React.createElement(React.Fragment, null,
            React.createElement(ListButton, { readOnly: isReadOnly, disabled: isDisabled, id: "addRowButton", key: "add", iconName: "add", content: "Insert new row", onClick: this.handleAdd(formData, schema) }),
            React.createElement(ListButton, { readOnly: isReadOnly, disabled: isDisabled, id: "deleteRowButton", key: "delete", iconName: "delete", content: "Delete selected row", onClick: this.handleDelete(formData) }),
            React.createElement(ListButton, { readOnly: isReadOnly, disabled: isDisabled, id: "duplicateRowButton", key: "duplicate", iconName: "duplicate", content: "Duplicate selected row", onClick: this.handleDuplicate }),
            React.createElement(ListButton, { readOnly: false, disabled: noRowsSelected, id: "copyRowButton", key: "paperclip", iconName: "paperclip", content: "Copy selected row", onClick: this.handleCopy }),
            React.createElement(ListButton, { readOnly: isReadOnly, disabled: isDisabled, id: "pasteRowButton", key: "git-push", iconName: "git-push", content: "Paste copied row", onClick: this.handlePaste }),
            React.createElement(ListButton, { readOnly: isReadOnly || this.state.focusedRow === 0, disabled: isDisabled, id: "moveUpRow", key: "moveUpRow", iconName: "arrow-up", content: "Move Current Row Up", onClick: this.handleMoveUp() }),
            React.createElement(ListButton, { readOnly: isReadOnly ||
                    (this.props.formData &&
                        this.state.focusedRow === this.props.formData.length - 1), disabled: isDisabled, id: "moveDownRow", key: "moveDownRow", iconName: "arrow-down", content: "Move Current Row Down", onClick: this.handleMoveDown() }),
            React.createElement(Popover, { content: React.createElement(Menu, null,
                    React.createElement(MenuItem, { icon: "cloud-download", onClick: this.exportCSVList, text: "Export CSV" })), usePortal: true, position: Position.BOTTOM_LEFT },
                React.createElement(Button, { icon: "more", minimal: true }))));
    }
    render() {
        const { uiSchema, errors } = this.props;
        const schema = getUnconditionalSchema(this.props.schema, this.props.formData);
        const partialSchema = schema.items;
        const currentSchema = Object.assign({}, partialSchema);
        const { isDisabled, isReadOnly, isHidden } = getUiProperties(uiSchema);
        if (isHidden) {
            return null;
        }
        else {
            const buttons = this.createButtons(isDisabled, isReadOnly, this.props.formData, schema);
            return (React.createElement("div", null,
                React.createElement("div", { className: "list-table-container" },
                    React.createElement("div", { className: "list-table-subcontainer" },
                        React.createElement("div", { className: "list-button-container" },
                            React.createElement("div", { className: "list-table-button-item" },
                                React.createElement(ListFormDialog, { schema: currentSchema, formData: this.state.currentData[this.state.focusedRow], title: schema.title + " - Row " + (this.state.focusedRow + 1), uiSchema: uiSchema, errors: errors, onChange: this.handleDialogChange, onNext: this.handleNextButton, onPrevious: this.handlePreviousButton, onCloseWithoutSaving: this.handleCloseWithoutSaving, onCloseAndSave: this.handleCloseAndSave, isOpen: this.state.isDialogOpen, openDialog: this.openDialog(schema) })),
                            buttons),
                        React.createElement(Tooltip, { content: (schema === null || schema === void 0 ? void 0 : schema.help) || (schema === null || schema === void 0 ? void 0 : schema.title) ||
                                "There is no help for this list", position: Position.TOP },
                            React.createElement("div", { className: "list-label-container" },
                                React.createElement("span", null, schema.title)))),
                    React.createElement(ListTableWrapper, { items: partialSchema, uiSchema: uiSchema, formData: this.props.formData, onRowSelect: this.handleRowSelect, onRowDoubleClick: this.handleDoubleClick(schema), onGridReady: this.onGridReady, disableHeaderEdition: isReadOnly, setFieldColumn: this.setFieldColumn, onFirstDataRendered: this.onFirstDataRendered })),
                React.createElement(ErrorListComponent, { errorSet: errors })));
        }
    }
}
const mapDispatchToProps = (dispatch, { notifications }) => ({
    showNotification: (payload) => dispatch(notifications.actions.addNotification(payload)),
});
const contextConfig = {
    notifications: NotificationContext,
};
export const ListWrapper = (_a) => {
    var { uiSchema, onChange, setSelectedPanel, showNotification, formData } = _a, rest = __rest(_a, ["uiSchema", "onChange", "setSelectedPanel", "showNotification", "formData"]);
    const showNotificationMemo = React.useCallback((payload) => {
        showNotification(payload);
    }, []);
    const setSelectedPanelMemo = React.useCallback((id, plotPath) => setSelectedPanel(id, plotPath), []);
    return (React.createElement(List, Object.assign({ showNotification: showNotificationMemo, setSelectedPanel: setSelectedPanelMemo, uiSchema: uiSchema, onChange: onChange, formData: formData }, rest)));
};
const Connected = connect(null, mapDispatchToProps)(ListWrapper);
export default withContext(contextConfig)(Connected);
//# sourceMappingURL=List.js.map